export default "__VITE_ASSET__DbGRUaQt__"